import { Link } from 'react-router-dom';
import { Building2, LayoutDashboard, FileBarChart, Settings } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { usePermission } from '../../auth/AuthContext';

/**
 * Single entry point for everything Partner Due Diligence related -
 * per explicit direction, the Registry, Dashboard, Reports, and
 * Scoring Setup no longer each get their own sidebar entry; this hub
 * is the one sidebar link, and it fans out from here. Scoring Setup
 * only shows for those with model.view - it stays a genuinely
 * separate, restricted area even though it's reachable from here.
 */
export function PartnerDueDiligenceHubPage() {
  const canViewScoringSetup = usePermission('partner.due_diligence.model.view');

  const cards = [
    { to: '/partners', icon: Building2, title: 'Partner Registry', description: 'Register, search, and manage partner organizations and their due diligence cases.' },
    { to: '/partners-dashboard', icon: LayoutDashboard, title: 'Dashboard', description: 'Live KPIs, risk breakdown, renewals due, and outstanding actions across the portfolio.' },
    { to: '/partners-reports', icon: FileBarChart, title: 'Reports', description: 'Partner Register, Risk Register, Expiring Documents, Partner Performance, and more.' },
    ...(canViewScoringSetup ? [{ to: '/admin/partner-due-diligence-scoring', icon: Settings, title: 'Scoring Setup', description: 'System configuration for scoring models, criteria, risk bands, and approval routing.' }] : []),
  ];

  return (
    <div className="page">
      <PageHeader title="Partner Due Diligence" description="Everything related to partner onboarding, assessment, and ongoing monitoring." />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 }}>
        {cards.map((c) => (
          <Link key={c.to} to={c.to} className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
            <c.icon size={28} style={{ marginBottom: 8 }} />
            <h3>{c.title}</h3>
            <p className="muted">{c.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
